import React, { useEffect, useState } from "react";
import logo from "./../../../assets/images/LogoTransparent.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./DeliveryManLogin.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import warningImg from "./../../../assets/images/exclamation.png";
import EmployeeRegistrationForm from "../../restaurantsetup/components/EmployeeRegistrationForm/EmployeeRegistrationForm.tsx";
import DeliveryManRegistrationForm from "../DeliveryManRegistrationForm/DeliveryManRegistrationForm.tsx";

function DeliveryManLogin(props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loadedForTheFirstTime, setLoadedForTheFirstTime] = useState(false);
  const [userFound, setUserFound] = useState(false);
  const [passwordNotFound, setPasswordNotFound] = useState(false);
  const [userNameNotFound, setUserNameNotFound] = useState(false);
  const [open, setOpen] = useState(false);
  const [courierId, setCourierId] = useState(null);
  const [url, setUrl] = useState("");
  const [courierDetails, setCourierDetails] = useState([]);
  const [isLinkValid, setIsLinkValid] = useState(true);
  const [isLinkAlreadyUsed, setIsLinkAlreadyUsed] = useState(false);
  const [isCheckingLink, setIsCheckingLink] = useState(true);
  const [isLoggingIn, setIsLoggingIn] = useState(false); // ← NEW: loading state

  const apiAddress = process.env.REACT_APP_SECRET || "https://localhost:7175";

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const fullCurrentUrl = window.location.href;
    setUrl(fullCurrentUrl);
    setIsCheckingLink(true);

    axios
      .post(
        `${apiAddress}/api/DeliveryMan/GetCourierIdByInvitationUrl?url=${encodeURIComponent(
          fullCurrentUrl
        )}`
      )
      .then((res) => {
        setCourierDetails(res.data);
        setCourierId(res.data.courierId);
        if (res.data && res.data.isActive === true) {
          setIsLinkValid(true);
          setIsLinkAlreadyUsed(false);
        } else {
          setIsLinkValid(false);
          setIsLinkAlreadyUsed(true);
        }
      })
      .catch((err) => {
        setIsLinkValid(false);
        setIsLinkAlreadyUsed(false);
        toast.error("Could not find invitation", { theme: "colored" });
      })
      .finally(() => {
        setIsCheckingLink(false);
      });
  }, []);

  const ProceedLoginusiingAPI = async (e) => {
    e.preventDefault();

    if (!username.trim() || !password) {
      toast.error("Please enter username and password", {
        position: "top-right",
        autoClose: 4000,
        theme: "colored",
      });
      return;
    }

    setIsLoggingIn(true);

    try {
      const params = new URLSearchParams({
        userName: username.trim(),
        password: password,
      });

      const response = await axios.post(
        `${apiAddress}/api/CourierLogin?${params.toString()}`
      );

      const token = response.data?.token;

      if (!token) {
        throw new Error("No authentication token received");
      }

      // ─── SUCCESS ───────────────────────────────────────────────
      localStorage.setItem("gotasteadmintoken", token);

      toast.success("Login successful! Redirecting to delivery portal...", {
        position: "top-right",
        autoClose: 2200,
        theme: "colored",
      });

      setTimeout(() => {
        window.location.href = "http://localhost:5173/choose-type";
      }, 500);

    } catch (error) {
      console.error("Login error:", error);

      let errorMessage = "Login failed. Please try again.";

      if (axios.isAxiosError(error) && error.response) {
        const status = error.response.status;
        const serverMsg =
          error.response.data?.status ||
          error.response.data?.message ||
          error.response.data ||
          "";

        if (status === 401 || status === 400) {
          if (
            serverMsg.toLowerCase().includes("password") ||
            serverMsg.toLowerCase().includes("invalid")
          ) {
            setPasswordNotFound(true);
            errorMessage = "Incorrect password";
          } else if (
            serverMsg.toLowerCase().includes("user") ||
            serverMsg.toLowerCase().includes("not found") ||
            serverMsg.toLowerCase().includes("username")
          ) {
            setUserNameNotFound(true);
            errorMessage = "Username not found";
          } else {
            errorMessage = serverMsg || "Invalid login credentials";
          }
        } else if (status === 403) {
          errorMessage = "Account is deactivated or access denied";
        } else if (status === 500) {
          errorMessage = "Server error – please try again later";
        } else {
          errorMessage = serverMsg || `Error ${status}`;
        }
      } else {
        errorMessage =
          "Network error. Please check your internet connection.";
      }

      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        theme: "colored",
      });
    } finally {
      setIsLoggingIn(false);
    }
  };

  const modalClose = (data) => {
    setOpen(data);
  };

  const modalOpen = () => {
    if (!isLinkValid) {
      toast.warn("Cannot register with this link.", { theme: "colored" });
      return;
    }
    setOpen(true);
  };

  return (
    <div style={{ height: "100vh" }}>
      <ToastContainer />

      {isCheckingLink ? (
        <div className="d-flex align-items-center justify-content-center h-100">
          <div className="text-center">
            <div
              className="spinner-border text-primary"
              role="status"
              style={{ width: "3rem", height: "3rem" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Validating invitation link...</p>
          </div>
        </div>
      ) : (
        <>
          {isLinkValid && (
            <DeliveryManRegistrationForm
              courierId={courierId}
              url={url}
              email={courierDetails.email}
              open={open}
              modalClose={modalClose}
            />
          )}

          <div className="divClass"></div>

          <div className="container login d-flex align-items-center justify-content-center h-100">
            {isLinkAlreadyUsed ? (
              <div
                className="card p-5 text-center shadow"
                style={{ maxWidth: "500px" }}
              >
                <img
                  src={warningImg}
                  alt="Warning"
                  style={{ width: "80px", margin: "0 auto 1.5rem" }}
                />
                <h4 className="text-danger mb-3">Link Already Used</h4>
                <p className="lead mb-4">
                  An account has already been registered using this invitation
                  link.
                </p>
                <p className="text-muted">
                  Please contact support or ask for a new invitation link.
                </p>
                <button
                  className="btn btn-outline-primary mt-3"
                  onClick={() => (window.location.href = "http://localhost:5173")}
                >
                  Go to Login
                </button>
              </div>
            ) : (
              <form
                onSubmit={ProceedLoginusiingAPI}
                className="custom-loginForm loginCardKYC"
              >
                <div className="container">
                  <div className="d-flex justify-content-center">
                    <img
                      src={logo}
                      alt=""
                      style={{ width: "6.5rem", marginBottom: "1rem" }}
                    />
                  </div>

                  <h5 className="goTasteH3 d-flex justify-content-center">
                    Welcome To GoTaste Admin Panel for delivery man
                  </h5>

                  <div className="row mt-3">
                    <div className="col-12">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control login-info"
                          value={username}
                          placeholder="Enter Email / User Name"
                          onChange={(e) => setUsername(e.target.value)}
                          disabled={isLoggingIn}
                        />
                        <span
                          className={`${userNameNotFound ? "" : "d-none"}`}
                          style={{ color: "red", fontSize: ".8rem" }}
                        >
                          Enter Email / User Name not found *
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-12">
                      <div className="form-group">
                        <input
                          type="password"
                          className="form-control login-info"
                          value={password}
                          placeholder="Password"
                          onChange={(e) => setPassword(e.target.value)}
                          disabled={isLoggingIn}
                        />
                        <span
                          className={`${passwordNotFound ? "" : "d-none"}`}
                          style={{ color: "red", fontSize: ".8rem" }}
                        >
                          Password not matched *
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-12">
                      <span className="text-muted span-text">
                        You can use your existing GoTaste account to login
                      </span>
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-12 d-flex justify-content-center">
                      <button
                        className="btn btn-success font-weight-bold w-100"
                        style={{ borderRadius: "8px" }}
                        type="submit"
                        disabled={isLoggingIn}
                      >
                        {isLoggingIn ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            ></span>
                            Logging in...
                          </>
                        ) : (
                          "Login"
                        )}
                      </button>
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-12 d-flex justify-content-between">
                      <span className="text-muted span-text">
                        Don't have any account?
                      </span>
                      <span
                        className="span-text"
                        style={{ color: "blue", cursor: "pointer" }}
                        onClick={modalOpen}
                      >
                        Create account
                      </span>
                    </div>
                  </div>
                </div>
              </form>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default DeliveryManLogin;